var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          staticClass: "mt14 card-box",
          attrs: { "body-style": { padding: "0 0 20px 0 " } },
        },
        [
          _c("div", { staticClass: "header" }, [
            _c("div", { staticClass: "left" }, [
              _c("i", {
                staticClass: "el-icon-arrow-left",
                on: { click: _vm.backFn },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "invoice-logo" }, [
                _c("i", { staticClass: "icon iconfont iconshitosheji" }),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "right" },
              [
                _c("span", { staticClass: "title" }, [_vm._v("实体设计")]),
                _vm._v(" "),
                _c(
                  "el-tabs",
                  {
                    staticClass: "tab",
                    model: {
                      value: _vm.activeName,
                      callback: function ($$v) {
                        _vm.activeName = $$v
                      },
                      expression: "activeName",
                    },
                  },
                  _vm._l(_vm.tabArray, function (item, index) {
                    return _c(
                      "el-tab-pane",
                      { key: index, attrs: { name: item.value } },
                      [
                        _c("div", { attrs: { slot: "label" }, slot: "label" }, [
                          _c("span", [_vm._v(_vm._s(item.label))]),
                        ]),
                      ]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ml20 mr20" },
            [
              _vm.activeName == 1
                ? _c("basic-setting", { attrs: { infoData: _vm.info } })
                : _vm._e(),
              _vm._v(" "),
              _vm.activeName == 2
                ? _c("field-setting", {
                    staticClass: "mt20",
                    attrs: { infoData: _vm.info },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.activeName == 3
                ? _c("form-design", { staticClass: "mt20" })
                : _vm._e(),
              _vm._v(" "),
              _vm.activeName == 4
                ? _c("list-setting", {
                    ref: "listSetting",
                    attrs: { infoData: _vm.info },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.activeName == 5
                ? _c("process-setting", {
                    staticClass: "mt20",
                    attrs: { infoData: _vm.info },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.activeName == 6
                ? _c("event-setting", {
                    staticClass: "mt20",
                    attrs: { infoData: _vm.info },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }